import { doc, setDoc, getDoc, serverTimestamp, collection, query, where, getDocs, addDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import * as firebase from 'firebase/app';

// product: { id, name, image, ... }
// buyer: { uid, email, name }
// seller: { uid, email, name }
// adminEmail: string (default 'ytproudltd@gmail.com')
export async function createOrGetProductChat(product, buyer, seller, adminEmail = 'ytproudltd@gmail.com') {
  try {
    console.log('[createOrGetProductChat] called with:', { product, buyer, seller, adminEmail });
    const conversationsRef = collection(db, 'sellerbuyerconversations');
    const buyerSellerKey = `${buyer.email.toLowerCase()}_${seller.email.toLowerCase()}`;
    console.log('[createOrGetProductChat] conversationsRef:', conversationsRef.path, 'buyerSellerKey:', buyerSellerKey);

    // Find existing conversation
    const q = query(
      conversationsRef,
      where('buyerSellerKey', '==', buyerSellerKey),
      where('type', '==', 'product_chat')
    );
    const querySnapshot = await getDocs(q);

    let existingConversation = null;
    querySnapshot.forEach((docSnap) => {
      existingConversation = { id: docSnap.id, ...docSnap.data() };
    });

    const newProduct = {
      id: product.id || 'unknown',
      name: product.name || 'Unknown Product',
      image: product.image || '',
      price: product.price || ''
    };

    if (existingConversation) {
      console.log('[createOrGetProductChat] Found existing conversation:', existingConversation.id);
      const docRef = doc(db, 'sellerbuyerconversations', existingConversation.id);
      const existingProducts = Array.isArray(existingConversation.products) ? existingConversation.products : [];
      // Check if product already exists in array
      const alreadyExists = existingProducts.some(p => p.id === newProduct.id);
      const updatedData = {
        product_id: newProduct.id,  // For quick access to last clicked product
        product_name: newProduct.name,
        product_image: newProduct.image,
        product_price: newProduct.price,
        lastContactedAt: serverTimestamp(), // Track when this product was last contacted
        ...(alreadyExists ? {} : { products: [...existingProducts, newProduct] })
      };
      console.log('[createOrGetProductChat] Updating existing conversation with new product details:', docRef.path, updatedData);
      await setDoc(docRef, updatedData, { merge: true });
      console.log('[createOrGetProductChat] Redirecting to existing conversation:', existingConversation.id);
      return existingConversation.id;
    } else {
      // Create new conversation
      const conversationData = {
        members: [buyer.email, seller.email, adminEmail],
        buyer,
        seller,
        admin: { email: adminEmail, name: 'Admin' },
        buyerSellerKey,
        products: [newProduct],
        product_id: newProduct.id,
        product_name: newProduct.name,
        product_image: newProduct.image,
        product_price: newProduct.price,
        type: 'product_chat',
        createdAt: serverTimestamp(),
        lastMessage: '',
        lastMessageTime: null,
        seller_username: seller.name || seller.username || 'unknown',
      };
      console.log('[createOrGetProductChat] Creating new conversation:', conversationData);
      const docRef = await addDoc(conversationsRef, conversationData);
      console.log('[createOrGetProductChat] Conversation created with ID:', docRef.id);
      return docRef.id;
    }
  } catch (error) {
    console.error('[createOrGetProductChat] Error:', error);
    throw error;
  }
}

export async function createTransactionConversation({
  admin,
  buyer,
  seller,
  product,
  orderStatus,
  category_name,
  order_id = '',
  order_total = '',
  order_date = '',
}) {
  try {
    console.log('[createTransactionConversation] called with:', { admin, buyer, seller, product, orderStatus, category_name, order_id, order_total, order_date });
    const buyerSellerKey = `${buyer.email || ''}_${seller.email || ''}`;
    const conversationsRef = collection(db, 'sellerbuyerconversations');
    console.log('[createTransactionConversation] conversationsRef:', conversationsRef.path, 'buyerSellerKey:', buyerSellerKey);
    let q = query(
      conversationsRef,
      where('buyerSellerKey', '==', buyerSellerKey),
      where('type', '==', 'transaction')
    );
    let querySnapshot = await getDocs(q);
    let existingConversation = null;
    querySnapshot.forEach((docSnap) => {
      existingConversation = { id: docSnap.id, ...docSnap.data() };
    });

    // Prepare flat fields as per sample
    const conversationData = {
      buyer: {
        buyer_username: buyer.buyer_username || '',
        email: buyer.email || '',
        name: buyer.name || '',
        uid: buyer.uid || ''
      },
      seller: {
        email: seller.email || '',
        name: seller.name || '',
        seller_username: seller.seller_username || '',
        uid: seller.uid || ''
      },
      buyerSellerKey,
      members: [
        buyer.email || '',
        seller.email || '',
        admin?.email || 'ytproudltd@gmail.com'
      ],
      order_date: order_date || '',
      order_id: order_id || '',
      order_total: order_total || '',
      product_id: product.id || '',
      product_image: product.image || '',
      product_name: product.name || '',
      product_price: product.price || '',
      status: orderStatus || '',
      type: 'transaction',
      category_name: category_name || '',
      createdAt: existingConversation ? existingConversation.createdAt : serverTimestamp(),
      lastMessage: '',
      lastMessageFrom: '',
      lastMessageTime: null
    };

    if (existingConversation) {
      const docRef = doc(db, 'sellerbuyerconversations', existingConversation.id);
      console.log('[createTransactionConversation] Updating existing conversation:', docRef.path, conversationData);
      await setDoc(docRef, conversationData, { merge: true });
      return existingConversation.id;
    } else {
      console.log('[createTransactionConversation] Creating new conversation:', conversationData);
      const docRef = await addDoc(conversationsRef, conversationData);
      console.log('[createTransactionConversation] Conversation created with ID:', docRef.id);
      return docRef.id;
    }
  } catch (error) {
    console.error('[createTransactionConversation] Error:', error);
    throw error;
  }
} 